module.exports = __webpack_public_path__ + "static/media/success_icon.21d163f9.svg";